import axiosInstance from '@/plugins/axios';

export default class ServiceUsuarios {
  static listar = (filtro = {}, { skip = 0, limit = 50 } = {}) =>
    axiosInstance.post(`auth/user/filter?skip=${skip}&limit=${limit}`, filtro);
  static buscar = (id) => axiosInstance.get(`auth/user/${id}`);
  static criar = (dados) => axiosInstance.post('auth/user', dados);
  static editar = (id, dados) => axiosInstance.patch(`auth/user/${id}`, dados);
  static bloquear = (id, ativo) => axiosInstance.patch(`auth/user/${id}`, { is_active: ativo });
  // Reset de senha por admin — dispara email KC (paridade legado UserController.reset).
  static resetarSenha = (email) => axiosInstance.post('auth/user/reset', { email });
  static existeEmail = (email) =>
    axiosInstance.get(`auth/user/exists/email?email=${encodeURIComponent(email)}`);
  static existeLogin = (login) =>
    axiosInstance.get(`auth/user/exists/login?login=${encodeURIComponent(login)}`);
  static empresas = (id) => axiosInstance.get(`auth/user/${id}/companies`);
  static setEmpresas = (id, lista) => axiosInstance.put(`auth/user/${id}/companies`, lista);
}
